import { IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { cloneElement, isValidElement, memo, useMemo } from "react";

import type { SefanoIconButtonProps } from "./SefanoIconButton.types";
import * as styles from "./SefanoIconButton.styles";

export type { SefanoIconButtonProps, SefanoIconButtonVariant } from "./SefanoIconButton.types";

export const SefanoIconButton = memo(function SefanoIconButton({
  children,
  iconColor,
  variant = "default",
  sx,
  size = "small",
  ...props
}: SefanoIconButtonProps) {
  const theme = useTheme();

  const resolvedColor = iconColor ?? theme.palette.text.secondary;

  const icon = useMemo(() => {
    if (!isValidElement<{ color?: string }>(children)) {
      return children;
    }

    return cloneElement(children, {
      color: children.props.color ?? resolvedColor,
    });
  }, [children, resolvedColor]);

  const variantStyle =
    variant === "danger"
      ? styles.outlinedDanger
      : variant === "plain"
        ? styles.plain
        : variant === "ghost"
          ? styles.ghost
          : styles.outlined;

  return (
    <IconButton size={size} sx={[variantStyle, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]} {...props}>
      {icon}
    </IconButton>
  );
});
